import {  put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch , handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    selectOptionRealPdf: "selectOptionRealPdf [Action]",
    selectOptionRealPdfLoading: "selectOptionRealPdfLoading [Action]",
    selectOptionRealPdfAsync: "selectOptionRealPdfAsync [Action]",
};

const inistiaState = {
    data: {},
    total:0,
    loading: false
};

export const reducerSelectOptionRealPdf = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectOptionRealPdf:
            return {
                ...state,
                data: payload.image_file,
                total: payload.image_file ? Object?.keys(payload.image_file)?.length :0
            };
        case actionTypes.selectOptionRealPdfLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectOptionRealPdfLoading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "brokercustomer",
        method_type: "select_option_real_pdf",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.selectOptionRealPdf, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.selectOptionRealPdfLoading, payload: false })

    }
}

export function* workerSelectOptionRealPdf() {
    yield takeLatest(actionTypes.selectOptionRealPdfAsync, handleWorker);
}
